import { Question, SkillType } from "@amzn/legal-ai-companion-types";

export const convertSampleQuestionsToLegalAIQuestions = (
  sampleQuestions?: string[]
): Question[] => {
  return sampleQuestions?.map((sampleQuestion) => ({
    prompt: sampleQuestion,
  })) ?? [];
};

export const createKnowledgeBaseSkillConfiguration = (
  sampleQuestions: Question[],
  instanceId: string,
  documentGroupId: string,
  isCrossInstanceChatbotEnabled: boolean = false
) => {
  return {
    [SkillType.KnowledgeBase]: {
      title: "Pathfinder knowledge base",
      description: "I will answer questions from pathfinder knowledge base",
      sampleQuestions,
      type: SkillType.KnowledgeBase as SkillType.KnowledgeBase,
      attributeFilter: {
        andAllFilters: isCrossInstanceChatbotEnabled ? [] : [
          {
            equalsTo: {
              name: "instanceId",
              value: {
                stringValue: instanceId,
              },
            },
          },
        ],
      } as Record<string, unknown>,
      documentGroupId,
      informationPopoverHeader: "Pathfinder knowledge base",
      informationPopoverContent: "Answer questions using pathfinder knowledge base",
      disableDownloadResponse: true,
    },
  };
};

export const findInstanceConfig = (
  instancesConfig: any[] | undefined,
  instanceId: string
) => {
  return instancesConfig?.find(
    (config) => config.instanceId.toLowerCase() === instanceId.toLowerCase()
  );
};

export const setupRemoteModule = (url: string) => {
  if (typeof window !== "undefined") {
    window["remotes"] = { LegalGenAIUIAssets: url };
  }
};
